/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "addons": {
        "nested": {
          "data": {
            "nested": {
              "InstallationActionSource": {
                "values": {
                  "DO_NOT_USE_ACTION_SOURCE": 0,
                  "ADDONS_LIBRARY": 1,
                  "SUBSCRIPTIONS_FEED": 2,
                  "DASHBOARD_ACTION": 3,
                  "BACKFILL": 4,
                  "ONBOARDING": 5,
                  "SERVER_ACTION": 6,
                  "DEVICE_PROFILES_DASHBOARD": 7
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.addons?.nested?.data?.nested?.InstallationActionSource) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE InstallationActionSource @ squareup/addons/data/installation_action_source.proto at 8:1
 */
export const InstallationActionSource = $root.lookupEnum('squareup.addons.data.InstallationActionSource').values;